import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cde162d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-container" }
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "select-items-container" }
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = ["checked"]
const _hoisted_12 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "select",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenu()))
      }, _toDisplayString(_ctx.title), 1),
      _withDirectives((_openBlock(), _createElementBlock("svg", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clear())),
        xmlns: "http://www.w3.org/2000/svg",
        class: "closing-x",
        viewBox: "0 0 16 16"
      }, _hoisted_4, 512)), [
        [_vShow, this.checkedTags.length > 0]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("svg", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMenu())),
        xmlns: "http://www.w3.org/2000/svg",
        class: "arrow",
        viewBox: "0 0 16 16"
      }, _hoisted_6, 512)), [
        [_vShow, 
          (this.arrow === 'up' &&
            !this.$store.state.selectWindow.open &&
            this.$store.state.selectWindow.title === this.title) ||
          this.$store.state.selectWindow.title != this.title
        ]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("svg", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showMenu())),
        xmlns: "http://www.w3.org/2000/svg",
        class: "arrow",
        viewBox: "0 0 16 16"
      }, _hoisted_8, 512)), [
        [_vShow, 
          this.$store.state.selectWindow.open &&
          this.$store.state.selectWindow.title === this.title
        ]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "select-items",
          key: item
        }, [
          _createElementVNode("div", {
            id: item,
            onClick: ($event: any) => (_ctx.onClick(item))
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              class: "checkbox",
              checked: this.checkedTags.includes(item)
            }, null, 8, _hoisted_11),
            _createElementVNode("label", { for: item }, " " + _toDisplayString(item), 9, _hoisted_12)
          ], 8, _hoisted_10)
        ]))
      }), 128))
    ], 512), [
      [_vShow, 
        this.$store.state.selectWindow.open &&
        this.$store.state.selectWindow.title === this.title
      ]
    ])
  ])), [
    [_directive_click_outside, _ctx.hideMenu]
  ])
}